import { takeLatest } from "redux-saga/effects";

import { ToastError, ToastSuccess } from "../../components/Global/Toasts/Toasty";
import { makePayload, generateDefaultActions, requestSaga } from "../../shared-utility/store/utils/helpers";

export const APPS_PAGE_GET_APPS = generateDefaultActions("APPS_PAGE_GET_APPS");
export const getApps = () => makePayload(APPS_PAGE_GET_APPS.value);
function* getAppsSaga() {
  yield requestSaga(APPS_PAGE_GET_APPS, "/apps");
}

export const APPS_PAGE_ACTIVATE_APP = generateDefaultActions("APPS_PAGE_ACTIVATE_APP");
export const activateApp = appId => ({ type: APPS_PAGE_ACTIVATE_APP.value, appId });
function* activateAppSaga(payload) {
  yield requestSaga(APPS_PAGE_ACTIVATE_APP, `/apps/${payload.appId}/activate`, "post");
}

export const APPS_PAGE_DEACTIVATE_APP = generateDefaultActions("APPS_PAGE_DEACTIVATE_APP");
export const deactivateApp = appId => ({ type: APPS_PAGE_DEACTIVATE_APP.value, appId });
function* deactivateAppSaga(payload) {
  yield requestSaga(APPS_PAGE_DEACTIVATE_APP, `/apps/${payload.appId}/deactivate`, "post");
}

const initialState = {};

export function appsPageReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case APPS_PAGE_GET_APPS.success:
      return { ...state, apps: payload.data };
    case APPS_PAGE_GET_APPS.failure:
      ToastError("Failed to get apps");

      return { ...state, apps: undefined };
    case APPS_PAGE_ACTIVATE_APP.success:
      ToastSuccess("Activated app");

      return { ...state, apps: payload.data };
    case APPS_PAGE_ACTIVATE_APP.failure:
      ToastError("Failed to activate app");

      return { ...state };
    case APPS_PAGE_DEACTIVATE_APP.success:
      ToastSuccess("Deactivated app");

      return { ...state, apps: payload.data };
    case APPS_PAGE_DEACTIVATE_APP.failure:
      ToastError("Failed to deactivate app");

      return { ...state };
    default:
      return state;
  }
}

export function* appsPageSaga() {
  yield takeLatest(APPS_PAGE_GET_APPS.value, getAppsSaga);
  yield takeLatest(APPS_PAGE_ACTIVATE_APP.value, activateAppSaga);
  yield takeLatest(APPS_PAGE_DEACTIVATE_APP.value, deactivateAppSaga);
}
